import React from 'react';
import './yujiezju.css';
import {  Layout, Avatar } from 'antd';
import myAvatar from './images/myAvatar.jpg';
import { Link } from 'react-router-dom';

const { Header, Content, Footer } = Layout;

const Page2 = () => {
    return(
        <Layout className='layout'>
            <Header className='header'>
                <h1>流 霜</h1>
            </Header>
            <Layout>
                <Content className='content'>
                    <br/><br/><br/>
                    
                    <Avatar
                        size={{
                        xs: 110,
                        sm: 130,
                        md: 150,
                        lg: 180,
                        xl: 210,
                        xxl: 330,
                        }}
                        src={myAvatar}
                    />      
                    <div className='href-list'>
                        <div><h1>友 链</h1></div>
                    
                    
                        <a href='https://zjuidg.org' className='href-friend' target='_blank'>
                        ZJUIDG</a>                  
                    
                        <a href='https://jzl-66666a.github.io' className='href-friend' target='_blank'>
                        66666a</a>                    
                    
                        <a href='https://hzeroyuke.github.io/my_blog/' className='href-friend' target='_blank'>
                        厉害的华零</a>                    
                    
                        <a href='https://note.jiepeng.tech/' className='href-friend' target='_blank'>
                        混高真神杰哥</a>

                        <a href='https://csfufu.life' className='href-friend' target='_blank'>
                        大帅哥fufu</a>

                        <a className='href-friend'>
                            <a href='https://night1918.top/' className='href-friend' target='_blank'>
                            夜辰Night</a>
                            <l className='href-friend'>&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;</l>
                            <a href='http://121.199.76.70/blog/' className='href-friend' target='_blank'>
                            qfqfqf</a>
                        </a>

                        <a className='href-friend'>
                            <a href='https://ottohere-mourn.github.io/' className='href-friend' target='_blank'>
                            木槿花mjh</a>
                            <l className='href-friend'>&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</l>
                            <a href='https://jybestow.github.io/' className='href-friend' target='_blank'>
                            嘎嘎</a>                            
                        </a>


                    
                    <p><Link to="/" style={{color: "#F1AC7C"}}>返回主页</Link></p>
                    
                    </div>
                </Content>               
            </Layout>
            <Footer className='foot'>
            <a 
                href="https://beian.miit.gov.cn/" 
                target="_blank" 
                rel="noreferrer" 
                style={{color: 'gray'}}>
                滇ICP备2023016012号-2
            </a>
            </Footer>
        </Layout>
    );
}
export default Page2;